import React from 'react';
import { teachersData } from '../content';
import TeacherCard from '../components/teachers/TeacherCard';

const TeachersPage = () => {
  return (
    <div className="container">
      <h1>Průvodci</h1>
      
      <div className="intro-text">
        <p>{teachersData.introduction}</p>
      </div>
      
      <div className="teachers-list">
        {teachersData.teachers.map((teacher, index) => (
          <TeacherCard 
            key={teacher.id} 
            teacher={teacher} 
            isEven={index % 2 === 0} 
          />
        ))}
      </div>
    </div>
  );
};

export default TeachersPage; 